import React, { useCallback, useEffect, useState } from "react";
import { Form, Input, Row, Col, Modal, Button } from "antd";

import { Container } from "./styles";
import { openNotification } from "../../../../../../components/Notification";
import { useWidth } from "../../../../../../hooks";
import { identidadeGeneroService } from "../../../../../../services/resources/identidadeGeneroService";
import TextArea from "antd/lib/input/TextArea";


export function ModalAdd({ onClose, mode, codigo, reload }) {
  const [form] = Form.useForm();
  const { width } = useWidth();

  const [loading, setLoading] = useState(false);

  const [identidadeGenero, setIdentidadeGenero] = useState([]);

  const handleCloseModal = useCallback(() => {
    onClose();
  }, [onClose]);

  useEffect(() => {
    async function getIdentidadeGenero() {
      try {
        const { data } = await identidadeGeneroService.get(codigo);

        setIdentidadeGenero(data);
        form.setFieldsValue({
          descricao: data?.descricao,
          fundamentacao: data?.fundamentacao,
        });
      } catch (error) {
        openNotification(
          "error",
          <strong>Erro!</strong>,
          error?.response?.data?.detail
        );
      }
    }
    if (mode !== "onCreate") {
      getIdentidadeGenero();
    }
  }, [codigo, mode, form]);

  async function create() {
    try {
      setLoading(true);
      await identidadeGeneroService.create(form.getFieldsValue());
      handleCloseModal();
      openNotification(
        "success",
        <strong>Identidade de gênero adicionado com sucesso!</strong>
      );
      reload();
    } catch (error) {
      handleCloseModal();
      openNotification(
        "error",
        <strong>Não foi possível criar a identidade de gênero!</strong>,
        error?.response?.data?.detail
      );
    } finally {
      setLoading(false);
    }
  }

  async function edit() {
    try {
      setLoading(true);
      await identidadeGeneroService.edit(codigo, form.getFieldsValue());
      handleCloseModal();
      openNotification("success", <strong>Identidade de gênero editado!</strong>);
      reload();
    } catch (error) {
      handleCloseModal();
      openNotification(
        "error",
        <strong>Não foi possível editar a identidade de gênero!</strong>,
        error?.response?.data?.detail
      );
    } finally {
      setLoading(false);
    }
  }

  const footer = [
    mode === "onCreate" && (
      <Button key="submit" onClick={create} type="primary" loading={loading}>
        cadastrar
      </Button>
    ),
    mode === "onEdit" && (
      <Button
        key="submitUpdate"
        onClick={edit}
        type="primary"
        loading={loading}
      >
        atualizar
      </Button>
    ),
  ];

  return (
    <Modal
      title={
        (mode === "onCreate" && "NOVA IDENTIDADE DE GÊNERO") ||
        (mode === "onEdit" && `EDITAR IDENTIDADE DE GÊNERO - ${identidadeGenero?.descricao}`) ||
        (mode === "onView" && `DETALHES DA IDENTIDADE DE GÊNERO - ${identidadeGenero?.descricao}`)
      }
      width={width > 1280 ? "50vw" : "100vw"}
      onCancel={onClose}
      visible
      footer={footer}
      centered
    >
      <Container>
        <Form form={form} name="identidadeGenero" layout="vertical">
          <Row>
            <Col span={24}>
              <Form.Item name="descricao" label={<span>Descrição:</span>}>
                <Input
                  type="text"
                  placeholder="insira a descrição"
                  autoComplete="none"
                  disabled={mode === "onView"}
                />
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} lg={{ span: 24 }}>
                <Form.Item
                  name="fundamentacao"
                  label={<span>Fundamentação:</span>}
                >
                  <TextArea
                    autoSize
                    placeholder="Digite a fundamentação da identidade de gênero"
                    disabled={mode === "onView"}
                  />
                </Form.Item>
              </Col>
          </Row>
        </Form>
      </Container>
    </Modal>
  );
}
